import React from 'react';

interface CustomNode {
  name: string;
  attribs?: {
    'data-type'?: string;
  };
}

export function NotificationsSpan(
  parseDate: (rawDate: string) => string,
  cls: Record<string, string>
) {
  return function CustomAnchor(
    node: CustomNode,
    children: React.ReactNode | string
  ) {
    const type = node?.attribs?.['data-type'];

    if (type === 'date' && children?.toString()) {
      const date = parseDate(children?.toString());

      return <span>{date}</span>;
    }

    return <span>{children}</span>;
  };
}
